/**
 * @license
 * Copyright (c) 2014, 2024, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
/**
 * A top-level require call executed by the Application.
 * Although 'knockout' would be loaded in any case (it is specified as a  dependency
 * by some modules), we are listing it explicitly to get the reference to the 'ko'
 * object in the callback
 */
 require(['ojs/ojbootstrap', 'knockout', 'ojs/ojmodule', 'underscore',
        'unifier/loginModel',
        'jquery',
        'studio/jquery-sha256',
        'ojs/ojknockout-validation',
        'ojs/ojdialog',
        'ojs/ojpopup',
        'ojs/ojvalidation',
        "ojs/ojprogress-circle",
        'ojs/ojbutton', 
        'ojs/ojformlayout',
        'ojs/ojmessages',
        'ojs/ojinputtext',
        'ojs/ojlabelvalue',
        'ojs/ojlabel',
        'ojs/ojdefer',
        'ojs/ojcheckboxset',
        'ojs/ojoption',
        'ojs/ojselectsingle'
 ],
 function (Bootstrap, ko, ModuleBinding, _, LoginModel) {
   window._ = _;
   Bootstrap.whenDocumentReady().then( function() {
      //ModuleBinding.defaults.viewPath = 'text!templates/';
      ModuleBinding.defaults.viewSuffix = '.tmpl.html';
      window._P.initPage(ko, LoginModel);
  });
 }
);
